<template>
    <div class="p-6 pb-10 mb-15 shadow-md rounded-md">
        <h3 class="text-2xl font-bold">Profile fields</h3>
        <p class="text-base leading-5">
            Define any additional default profile fields you wish to add (E.G department name, age, gender, etc.)
        </p>

        <div class="mt-6">
            <form @submit.prevent="submit">
                <div class="lg:w-1/2">
                    <div v-for="(systemProfileField, index) in systemProfileFields"
                         :key="'systemProfileField-' + index"
                         class="custom-field mb-6">
                        <label class="block text-sm mb-2" :for="'systemProfileField-' + index">
                            <span class="text-lg font-semibold leading-6 mb-2.5">Field Name</span>
                        </label>
                        <div class="relative">
                            <jet-input :id="'systemProfileField-' + index"
                                       type="text"
                                       :readonly="true"
                                       :value="systemProfileField"
                                       @keydown.enter.prevent.stop
                                       class="block w-full pr-20"
                            />
                        </div>
                    </div>
                    <div v-for="(_, index) in form.profileFields" :key="'profileField-' + index"
                         class="custom-field mb-6">
                        <label class="block text-sm mb-2" :for="'profileField-' + index">
                            <span class="text-lg font-semibold leading-6 mb-2.5">Field Name</span>
                        </label>
                        <div class="relative" ref="profileFieldsInputs">
                            <jet-input :id="'profileField-' + index"
                                       :ref="setProfileFieldsInputsRef"
                                       type="text"
                                       v-model="form.profileFields[index]"
                                       @keydown.enter.prevent.stop="newProfileField"
                                       class="block w-full pr-20"
                            />
                            <button @click.prevent="removeProfileField(index)"
                                    class="absolute inset-y-0 right-0 px-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-dark border border-transparent rounded-r-md">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                                     fill="none" viewBox="0 0 24 24" stroke="white">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                </svg>
                            </button>
                        </div>
                        <jet-input-error :message="form.errors['profileFields.' + index]" ></jet-input-error>
                    </div>
                </div>
                <div class="flex justify-between">
                    <jet-button @click.prevent="newProfileField" :has-icon="true" :bg-dark="true">
                        New Field
                    </jet-button>
                    <div class="flex items-center items-center">
                        <jet-action-message :on="form.recentlySuccessful" class="ml-auto mr-3">
                            Saved.
                        </jet-action-message>
                        <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" :bg-dark="true">
                            Save fields
                        </jet-button>
                    </div>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetActionMessage from "@/Jetstream/ActionMessage";
import JetButton from '@/Jetstream/Button.vue';

export default {
    name: "profileFieldsForm",
    components: {
        JetInput,
        JetInputError,
        JetActionMessage,
        JetButton,
    },
    props: {
        surveyType: {
            type: Number,
            required: true,
        },
        profileFields: {
            type: Array,
            required: true,
        },
        systemProfileFields: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                surveyType: this.surveyType,
                profileFields: this.profileFields,
            }),
            profileFieldsInputs: [],
        }
    },
    beforeUpdate() {
        this.profileFieldsInputs = [];
    },
    methods: {
        newProfileField() {
            let length = this.form.profileFields.push('');
            this.$nextTick(() => {
                this.profileFieldsInputs[length-1].focus()
            })
        },
        removeProfileField(index) {
            this.form.profileFields.splice(index, 1);
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                }))
                .post(this.route('admin.survey.defaults.save'), {
                    errorBag: 'profileFields',
                    preserveScroll: true,
                })
        },
        setProfileFieldsInputsRef(el) {
            if (el) {
                this.profileFieldsInputs.push(el)
            }
        }
    }
}
</script>

<style scoped>

</style>
